import { useTranslation } from 'react-i18next';

import { DefaultWidgetNames, WidgetType } from '@/api/rest/resources/types/widget';
import { WidgetSlotRenderer } from '@/components/widgets/WidgetSlotRenderer';
import { useWidgetSlotConfigurationByNameType } from '@/hooks/useWidgetConfigurationByOrganizationId';

import { PortfolioPageLayout } from '../../components/PortfolioPageLayout';
import { NaturalCapitalTables } from './components/NaturalCapitalTables';

export const PortfolioNaturalCapitalPage = () => {
  const { t } = useTranslation();

  const widgetSlotsConfiguration = useWidgetSlotConfigurationByNameType(
    DefaultWidgetNames.default_template_natural_capital,
    WidgetType.t_page,
  );

  return (
    <PortfolioPageLayout title={t('navbar.natureCapital')} showFilters={true}>
      <WidgetSlotRenderer nestedWidget={widgetSlotsConfiguration} />
      <NaturalCapitalTables />
    </PortfolioPageLayout>
  );
};
